import styled from 'styled-components';

export const VideoModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 57px;

  .close {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
`;
VideoModalHeader.displayName = 'VideoModalHeader';

export const ModalStyleWrapper = styled.div`
  > dialog {
    width: calc(100% - 4rem);
    max-width: 1740px;
    margin: auto;

    @media (max-width: 960px) {
      max-height: 1000px;
    }

    div[id='videoPanel'] {
      position: absolute;
      top: 50px !important;
      left: 0 !important;
      width: 100%;
      height: 100%;
      text-align: center;
      vertical-align: middle;
      z-index: ${({ $zIndex }) => $zIndex || 98};
      margin: ${({ $margin }) => $margin || 0};
      background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
    }

    aside {
      height: 100%;

      h1 {
        line-height: 2;
      }

      ol {
        @media (min-width: 960px) and (max-width: 1500px) {
          max-height: calc(100vh - 300px) !important;
        }
        @media (min-width: 1500px) {
          max-height: initial !important;
        }
        height: 100vh;
      }
    }
  }
`;
ModalStyleWrapper.displayName = 'ModalStyleWrapper';
